<form [formGroup]="form">
  <div id="board-write">
    <div class="inner-wrap1">
      <table>
      <colgroup>
        <col style="width:14%">
        <col style="width:36%">
        <col style="width:14%">
        <col style="width:36%">
      </colgroup>

      <tbody>
      <ng-container *ngIf="group.length > 0">
        <tr>
          <th><i class="material-icons cred f11">star</i>구분</th>
          <td colspan="3">
            <select id="group_id" formControlName="group_id" [ngClass]="{formErrors:formErrors['group_id']}">
              <option *ngFor="let item of group" [value]="item.value">{{item.title}}</option>
            </select>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="params.board_id !== 'ahriconsult'">
        <tr>
          <th><i class="material-icons cred f11">star</i>제목</th>
          <td colspan="3"><input type="text" id="subject" formControlName="subject" [ngClass]="{formErrors:formErrors['subject']}" autofocus="true" /></td>
        </tr>
      </ng-container>

      <!-- 특허AHRI인증 컨설팅게시판 -->
      <ng-container *ngIf="params.board_id === 'ahriconsult'">
        <tr>
          <th><i class="material-icons cred f11">star</i>업체명</th>
          <td colspan="3">
            <input type="text" id="company_name" formControlName="company_name" [ngClass]="{formErrors:formErrors['company_name']}" />
          </td>
        </tr>
        <tr class="tr-ul">
          <td colspan="4" class="td-ul">
            <ul>
              <li>
                <p class="th"><i class="material-icons cred f11">star</i>담당자</p>
                <p class="td"><input type="text" id="charge" formControlName="charge" [ngClass]="{formErrors:formErrors['charge']}" /></p>
              </li>
              <li>
                <p class="th">이메일</p>
                <p class="td"><input type="text" id="contact_email" formControlName="contact_email" [ngClass]="{formErrors:formErrors['contact_email']}" /></p>
              </li>
              <li>
                <p class="th">연락처</p>
                <p class="td">
                  <input type="text" class="w60 mr10" id="tel1" formControlName="tel1" [ngClass]="{formErrors:formErrors['tel1']}" />
                  -<input type="text" class="w60 ml10 mr10" id="tel2" formControlName="tel2" [ngClass]="{formErrors:formErrors['tel2']}" />
                  -<input type="text" class="w60 ml10" id="tel3" formControlName="tel3" [ngClass]="{formErrors:formErrors['tel3']}" />
                  <span *ngIf="formErrors['tel1'] || formErrors['tel2'] || formErrors['tel3']">{{ formErrors['tel1'] ? formErrors['tel1'] : ( formErrors['tel2'] ? formErrors['tel2'] : ( formErrors['tel3'] ? formErrors['tel3'] : '' ) ) }}</span>
                </p>
              </li>
              <li>
                <p class="th">휴대전화</p>
                <p class="td">
                  <input type="text" class="w60 mr10" id="fax1" formControlName="hp1" [ngClass]="{formErrors:formErrors['hp1']}" />
                  -<input type="text" class="w60 ml10 mr10" id="fax2" formControlName="hp2" [ngClass]="{formErrors:formErrors['hp2']}" />
                  -<input type="text" class="w60 ml10" id="fax3" formControlName="hp3" [ngClass]="{formErrors:formErrors['hp3']}" />
                  <span *ngIf="formErrors['hp1'] || formErrors['hp2'] || formErrors['hp3']">{{ formErrors['hp1'] ? formErrors['hp1'] : ( formErrors['hp2'] ? formErrors['hp2'] : ( formErrors['hp3'] ? formErrors['hp3'] : '' ) ) }}</span>
                </p>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <th><i class="material-icons cred f11">star</i>신청프로그램</th>
          <td colspan="3"><input type="text" id="subject" formControlName="subject" [ngClass]="{formErrors:formErrors['subject']}" autofocus="true" /></td>
        </tr>
      </ng-container>
      <!-- AHRI인증 컨설팅게시판 -->

      <!-- 특허/인증 기술행정 자문 문의하기 -->
      <ng-container *ngIf="params.board_id === 'certification'">
        <tr>
          <th><i class="material-icons cred f11">star</i>회사명</th>
          <td colspan="3">
            <input type="text" id="company_name" formControlName="company_name" [ngClass]="{formErrors:formErrors['company_name']}" />
          </td>
        </tr>
        <tr class="tr-ul">
          <td colspan="4" class="td-ul">
            <ul>
              <li>
                <p class="th"><i class="material-icons cred f11">star</i>담당자</p>
                <p class="td"><input type="text" id="charge" formControlName="charge" [ngClass]="{formErrors:formErrors['charge']}" /></p>
              </li>
              <li>
                <p class="th">이메일</p>
                <p class="td"><input type="text" id="contact_email" formControlName="contact_email" [ngClass]="{formErrors:formErrors['contact_email']}" /></p>
              </li>
              <li>
                <p class="th"><i class="material-icons cred f11">star</i>연락처</p>
                <p class="td">
                  <input type="text" class="w60 mr10" id="tel1" formControlName="tel1" [ngClass]="{formErrors:formErrors['tel1']}" />
                  -<input type="text" class="w60 ml10 mr10" id="tel2" formControlName="tel2" [ngClass]="{formErrors:formErrors['tel2']}" />
                  -<input type="text" class="w60 ml10" id="tel3" formControlName="tel3" [ngClass]="{formErrors:formErrors['tel3']}" />
                  <span *ngIf="formErrors['tel1'] || formErrors['tel2'] || formErrors['tel3']">{{ formErrors['tel1'] ? formErrors['tel1'] : ( formErrors['tel2'] ? formErrors['tel2'] : ( formErrors['tel3'] ? formErrors['tel3'] : '' ) ) }}</span>
                </p>
              </li>
              <li>
                <p class="th">휴대전화</p>
                <p class="td">
                  <input type="text" class="w60 mr10" id="fax1" formControlName="hp1" [ngClass]="{formErrors:formErrors['hp1']}" />
                  -<input type="text" class="w60 ml10 mr10" id="fax2" formControlName="hp2" [ngClass]="{formErrors:formErrors['hp2']}" />
                  -<input type="text" class="w60 ml10" id="fax3" formControlName="hp3" [ngClass]="{formErrors:formErrors['hp3']}" />
                  <span *ngIf="formErrors['hp1'] || formErrors['hp2'] || formErrors['hp3']">{{ formErrors['hp1'] ? formErrors['hp1'] : ( formErrors['hp2'] ? formErrors['hp2'] : ( formErrors['hp3'] ? formErrors['hp3'] : '' ) ) }}</span>
                </p>
              </li>
              <li>
                <p class="th">부서</p>
                <p class="td"><input type="text" id="department" formControlName="department" [ngClass]="{formErrors:formErrors['department']}" /></p>
              </li>
              <li>
                <p class="th">직위</p>
                <p class="td"><input type="text" id="position" formControlName="position" [ngClass]="{formErrors:formErrors['position']}" /></p>
              </li>
            </ul>
          </td>
        </tr>
      </ng-container>
      <!-- 특허/인증 기술행정 자문 문의하기 -->

      <tr>
        <th><i class="material-icons cred f11">star</i>내용</th>
        <td colspan="3">
          <textarea class="contents" id="contents" formControlName="contents" [ngClass]="{formErrors:formErrors['contents']}"></textarea>
        </td>
      </tr>
      </tbody>
      </table>

      <div class="btn-area">
        <button class="add-btn" (click)="write()">등록</button>
        <button class="list-btn" (click)="list()">취소</button>
      </div>
    </div>
  </div>
</form>
